<template>
  <div>
    <PlaceholderPage 
      title="Riwayat Pembayaran" 
      :icon="['fas', 'receipt']"
      message="Halaman ini akan menampilkan riwayat lengkap transaksi pembayaran langganan Anda di HobiBaca, termasuk faktur, metode pembayaran, dan status pembayaran."
    />
  </div>
</template>

<script>
import PlaceholderPage from '@/components/PlaceholderPage.vue'

export default {
  name: 'PaymentHistory',
  components: {
    PlaceholderPage
  }
}
</script>